export function handleAxiosError(axiosError) {
  const response = axiosError.response;

  if (response.status === 401) {
    // auto logout if 401 response returned from api
    localStorage.removeItem("user");
    //location.reload(true);
  }
  console.log("got error", axiosError);
  if (response.data) {
    const error = (response.data && response.data.msg) || response.statusText;
    const additionalInformation = response.data.additionalInformation;
    return Promise.reject({
      error: error,
      additionalInformation: additionalInformation
    });
  } else {
    return Promise.reject({ error: response.statusText });
  }
}
